import { render, staticRenderFns } from "./ResetPassMailComposer.vue?vue&type=template&id=29c64b67&"
import script from "./ResetPassMailComposer.vue?vue&type=script&lang=js&"
export * from "./ResetPassMailComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports